module.exports = __webpack_public_path__ + "img/palmar-room.ddb0136c.jpg";